<template>
  <v-dialog
    v-model="visible"
    :fullscreen="mobileScreen"
    max-width="700px"
  >
    <v-card>
      <v-card-title class="card-title">
        <v-layout wrap>
          <v-flex xs10>
            <h2 class="text-xs-left display-3 sz_grafit--text ma-0 mt-1">
              {{ $t('family_card.revoke_publication.title') }}
            </h2>
          </v-flex>
          <v-flex xs2>
            <v-layout
              xs12
              justify-end
              align-center
            >
              <v-icon
                large
                class="clickable"
                @click="closeDialog()"
              >
                clear
              </v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="pb-2">
        <p class="text-xs-left f-16 sz_grafit--text ma-0 mt-1">
          {{ $t('family_card.revoke_publication.subtitle') }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-layout
          wrap
          align-center
          class="my-2"
          :column="$vuetify.breakpoint.xsOnly"
          :justify-space-between="$vuetify.breakpoint.smAndUp"
        >
          <v-flex
            order-xs2
            order-sm1
            class="lh-1 none-growth"
            :class="[mobileScreen ? 'mt-2' : 'mr-3']"
          >
            <a @click="closeDialog()">{{ $t('buttons.cancel') }}</a>
          </v-flex>
          <v-flex
            order-xs1
            order-sm2
            class="none-growth"
          >
            <v-btn
              color="sz_violet"
              :disabled="loading"
              :loading="loading"
              @click="save()"
            >
              {{ $t('buttons.revoke') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import filters from '@/constants/filters';

export default {
    name: 'RefuseReasonDialog',
    filters: {
        ...filters
    },
    props: ['show'],
    data () {
        return {
            visible: false,
            loading: false
        };
    },
    computed: {
        mobileScreen () {
            return this.$vuetify.breakpoint.xs;
        }
    },
    watch: {
        show (val) {
            this.visible = val;
        },
        visible (val) {
            this.$emit('show', val);
        }
    },
    methods: {
        closeDialog () {
            this.visible = false;
        },
        save () {
            this.loading = true;
            this.$store.dispatch('family/revokeFamily', this.$route.params.id).finally(() => {
                this.loading = false;
                this.closeDialog();
            });
        }
    }
};
</script>

<style scoped></style>
